import Swiper from 'swiper';

export default (itemsSliders) => {
    Array.from(itemsSliders).forEach(function (slider) {
        new Swiper(slider, {
            loop: true,
            speed: 600,
            spaceBetween: 0,
            slidesPerView: 2,
            navigation: {
                nextEl: slider.parentElement.getElementsByClassName('custom-slider__arrow--next')[0],
                prevEl: slider.parentElement.getElementsByClassName('custom-slider__arrow--prev')[0]
            },
            breakpoints: {
                768: {
                    spaceBetween: 0,
                    slidesPerView: 3,
                    pagination: false
                },
                1200: {
                    spaceBetween: 0,
                    slidesPerView: 4,
                    pagination: false
                },
                1600: {
                    spaceBetween: 0,
                    slidesPerView: 5,
                    pagination: false
                },
            }
        });
    })
}